import { http } from "@/http/http.js";
export default {
  //工单统计分页查询
  queryPage(params) {
    return http.post("/web/workOrder/queryPage", params);
  },
  //根据工单id查询详情
  workOrderDetail(params) {
    return http.post("/web/workOrder/detail", params);
  },
};
